import { useState, useEffect } from "react";
import { 
    Button,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Switch,
    FormControlLabel,
    DialogContent,
} from "@material-ui/core"
import PostAddIcon from '@material-ui/icons/PostAdd'
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { useFormik } from "formik"
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import { 
    obtenerCatalogoProveedorAereoAction, 
    crearVueloProveedorAction,  
    crearVueloCircuito, 
    obtenerVuelosPorCircuitoAction 
} from "../../../ducks/proveedorAereolineaDuck"
import AutoInputIATA from "../AutoInputIATA";
import PickerModHora from "../../../global/PickersModHora";
import { esFechaValida } from "../../../utils/FormatFecha";
// import ControllerEditor from "../../ProveedoresTerrestres/ControlledEditor";
import { FProveedorVuelosStyle } from "./styles";
import useCatalogos from "../../../hooks/useCatalogos";
import ExtrasCheckboxes, { convertExtrasToHTML, normalizarExtras } from "../ExtrasCheckboxes/ExtrasCheckboxes";

const useCatalogoPrveedoresAereos = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCatalogoProveedorAereoAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}

const useObtenerVuelosPorCircuito = (circuito) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerVuelosPorCircuitoAction({ idPaqueteCircuito: circuito?.IdPaqueteCircuito })).then(Response => {
            dispatch(offLoadAction())
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [circuito])
}

const validationSchema = yup.object({
    claveVuelo: yup
        .string("Ingrese una clave vuelo")
        .required("Es requerido"),
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Es requerido"),
    disponibilidad: yup
        .number("Ingresa un numero")
        .positive("Numero positivo")
        .required("Es requerido"),
    claveVueloRedondo: yup
        .string("Ingrese una clave vuelo")
        .required("Es requerido"),
})

const initialValues = {
    monto: 0,
    claveVuelo: "",
    regionVuelo: 0,
    disponibilidad: 0,
    claveVueloRedondo: "No aplica",
}

const FProveedoresVuelos = () => {
    const dispatch = useDispatch()
    const classes = FProveedorVuelosStyle()
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const catalogoClases = useCatalogos("Flight/Class")
    const catalogoVuelo = useCatalogos("Flight/Includes")

    const [open, setOpen] = useState(false)
    // const [value, setValue] = useState(0)
    const [idProveedor, setIdProveedor] = useState(0)
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const [claseVuelo, setClaseVuelo] = useState(0)
    const [claseVueloRedondo, setClaseVueloRedondo] = useState(0)
    const [regionVuelo, setRegionVuelo] = useState(0)
    const [isRedondo, setIsRedondo] = useState(false)

    const [itinerario, setItenerario] = useState('<p><strong>Escribe aqui el itinerario</strong></p>')
    const [incluye, setIncluye] = useState('<p><strong>Escribe aqui lo que incluye</strong></p>')
    const [noIncluye, setNoIncluye] = useState('<p><strong>Escribe aqui lo que No Incluye</strong></p>')

    const [destino, setDestino] = useState({ IdCodigo: 0 })
    const [origen, setOrigen] = useState({ IdCodigo: 0 })
    const [destinoRegreso, setDestinoRegreso] = useState({ IdCodigo: 0 })
    const [origenRegreso, setOrigenRegreso] = useState({ IdCodigo: 0 })
    const [shouldCloseAfterSave, setShouldCloseAfterSave] = useState(false)
    const [selectedExtrasIds, setSelectedExtrasIds] = useState([]);

    const [detallesDeVuelo, setDetallesDeVuelo] = useState({ 
        fechaSalida: new Date(),
        fechaLlegada: new Date(),
        fechaSalidaRedondo: new Date(),
        fechaLlegadaRedondo: new Date(),
    })
    
    const { circuitoSelect } = useSelector(store => store.proveedorTerrestre);
    const { catalogoProvAereo } = useSelector(store => store.vueloProveedor)
    
    const normalizedExtras = normalizarExtras(catalogoVuelo);

    useCatalogoPrveedoresAereos()
    useObtenerVuelosPorCircuito(circuitoSelect)

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values, shouldCloseAfterSave)
        },
    })
    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
        resetState()
    }
    const handleSelecProveedor = (event) => {
        setIdProveedor(event.target.value)
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }
    const handleSelecRegionVuelo = (event) => {
        setRegionVuelo(event.target.value)
    }
    const handleSelectClaseVuelo = (event) => {
        setClaseVuelo(event.target.value)
    }
    const handleSelectClaseVueloRedondo = (event) => {
        setClaseVueloRedondo(event.target.value)
    }
    // Manejar los estados de los campos de fecha
    const handleStateChange = (field, value) => {
       setDetallesDeVuelo((prev) => ({ ...prev, [field]: value }));
    };
    const handleClickSelecFecha = (field, date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        handleStateChange(field, date)
    }
    const handleClick = (shouldClose) => {
        setShouldCloseAfterSave(shouldClose); 
        formik.handleSubmit();
    }
    const handleChangeIsRedondo = (event) => {
        let redondo = event.target.checked
        setIsRedondo(redondo)
        if (redondo) {
            formik.setFieldValue("claveVueloRedondo", "")
        } else {
            formik.setFieldValue("claveVueloRedondo", "No aplica")
        }
    }
    const resetState = () => {
        formik.resetForm(initialValues);
        setTipoMoneda(0)
        setClaseVuelo(0)
        setRegionVuelo(0)
        setClaseVueloRedondo(0)
        setIsRedondo(false)
        setIdProveedor(0)

        setOrigen({ IdCodigo: 0 });
        setDestino({ IdCodigo: 0 });
        setOrigenRegreso({ IdCodigo: 0 });
        setDestinoRegreso({ IdCodigo: 0 });

        setItenerario('<p><strong>Escribe aqui el itinerario</strong></p>');
        setIncluye('<p><strong>Escribe aqui lo que incluye</strong></p>');
        setNoIncluye('<p><strong>Escribe aqui lo que No Incluye</strong></p>');
       
        setDetallesDeVuelo({
            fechaSalida: new Date(),
            fechaLlegada: new Date(),
            fechaSalidaRedondo: new Date(),
            fechaLlegadaRedondo: new Date(),
        });
    }
    const onSave = async (values, shouldClose) => {
        try {
          dispatch(onLoadAnction({ message: 'Creando vuelo...' }));
      
          if (tipoMoneda === 0) {
            ToastMessage.fire({
              icon: "warning",
              title: "Selecciona una moneda válida",
            });
            return;
          }
      
          if (idProveedor === 0) {
            ToastMessage.fire({
              icon: "warning",
              title: "Selecciona un proveedor válido",
            });
            return;
          }
      
          const vueloReondo = {
            IdCatVueloClase: claseVueloRedondo,
            ClaveVuelo: values?.claveVueloRedondo,
            FechaSalida: detallesDeVuelo?.fechaSalidaRedondo,
            FechaLlegada: detallesDeVuelo?.fechaLlegadaRedondo,
            IdOrigen: origenRegreso?.IdCodigo,
            IdDestino: destinoRegreso?.IdCodigo,
          };
      
          const payload = {
            IdProveedor: idProveedor,
            IdCatVueloClase: claseVuelo,
            IdCatRegion: regionVuelo,
            IdMoneda: tipoMoneda,
            ClaveVuelo: values?.claveVuelo,
            PrecioNeto: values?.monto,
            Disponibilidad: values?.disponibilidad,
            FechaSalida: detallesDeVuelo?.fechaSalida,
            FechaLlegada: detallesDeVuelo?.fechaLlegada,
            IdOrigen: origen?.IdCodigo,
            IdDestino: destino?.IdCodigo,
            Itinerario: itinerario,
            Incluye: incluye,
            NoIncluye: noIncluye,
            EsRedondo: isRedondo,
            VueloRedondo: vueloReondo,
            lCatIncluye: selectedExtrasIds
          };
      
          const responseVueloProveedor = await dispatch(crearVueloProveedorAction(payload));
      
          if (responseVueloProveedor.status === 500) {
            ToastMessage.fire({
              icon: "error",
              title: "Ha habido un problema, intenta más tarde",
            });
            return;
          }
      
          if (responseVueloProveedor.status === 400) {
            ToastMessage.fire({
              icon: "warning",
              title: responseVueloProveedor.Message,
            });
            return;
          }
      
          dispatch(onLoadAnction({ message: 'Creando circuito...' }));
      
          const responseVueloCircuito = await dispatch(crearVueloCircuito({
            IdPaqueteCircuito: circuitoSelect?.IdPaqueteCircuito,
            IdVueloProveedor: responseVueloProveedor,
          }));
      
          if (responseVueloCircuito.status === 500) {
            ToastMessage.fire({
              icon: "error",
              title: "Ha habido un problema, intenta más tarde",
            });
            return;
          }
      
          if (responseVueloCircuito.status === 400) {
            ToastMessage.fire({
              icon: "warning",
              title: responseVueloCircuito.Message,
            });
            return;
          }
      
          if (shouldClose) {
            handleClose();
          } else {
            resetState();
          }
      
          dispatch(obtenerVuelosPorCircuitoAction({
            idPaqueteCircuito: circuitoSelect?.IdPaqueteCircuito
          }));
      
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso correcto",
          });
      
        } catch (error) {
          console.error("Error inesperado en onSave:", error);
          ToastMessage.fire({
            icon: "error",
            title: "Ha ocurrido un error inesperado",
          });
        } finally {
          dispatch(offLoadAction());
        }
    };
  
    return (
        <>
            <Button variant="outlined" color="primary" onClick={handleOpen} endIcon={<PostAddIcon />} style={{ marginBottom: "1rem" }}>
                Nuevo vuelo
            </Button>
            <ModalBase classes={classes} open={open} onClose={handleClose} style={{ overflow: "scroll" , height: "90%", margin: "5rem auto", display: "block"}}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Nuevo vuelo ${circuitoSelect?.ClaveCircuito}`}
                />
                  
                <DialogContent dividers style={{ height: "70vh", maxHeight: '600px', overflowY: 'auto'}}>
                    <form>
                        <Grid container className={classes.containerSpacing}>
                            <Grid item xs={12}>
                                <Grid container className={classes.containerSpacing}>
                                    <Grid item xs={4}>
                                        <TextField
                                            required
                                            id="input-claveVuelo"
                                            label="Clave vuelo"
                                            type="text"
                                            variant="outlined"
                                            name="claveVuelo"
                                            value={formik.values.claveVuelo}
                                            onChange={formik.handleChange}
                                            error={formik.touched.claveVuelo && Boolean(formik.errors.claveVuelo)}
                                            helperText={formik.touched.claveVuelo && formik.errors.claveVuelo}
                                            className={classes.textField}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <TextField
                                            required
                                            id="input-disponibilidad-vuelo"
                                            label="Disponibilidad"
                                            type="text"
                                            variant="outlined"
                                            name="disponibilidad"
                                            value={formik.values.disponibilidad}
                                            onChange={formik.handleChange}
                                            error={formik.touched.disponibilidad && Boolean(formik.errors.disponibilidad)}
                                            helperText={formik.touched.disponibilidad && formik.errors.disponibilidad}
                                            className={classes.textField}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <InputLabel id="lTipoProveedorAereo">Proveedor aereo</InputLabel>
                                            <Select
                                                labelId="lTipoProveedorAereo"
                                                id="STipoProveedorAereo"
                                                name="proveedorAereo"
                                                value={idProveedor}
                                                onChange={handleSelecProveedor}
                                                label="Proveedor aereo"
                                            >
                                                <MenuItem value="0" disabled>
                                                    {"Seleccione una opción"}
                                                </MenuItem>
                                                {catalogoProvAereo.map((item, index) => (
                                                    <MenuItem key={item.IdProveedor} value={item.IdProveedor}>
                                                        {item.RazonSocial}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <AutoInputIATA
                                            label="Origen"
                                            name="Origen"
                                            setTarget={setOrigen}
                                            value={origen}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <AutoInputIATA
                                            label="Destino"
                                            name="destino"
                                            setTarget={setDestino}
                                            value={destino}
                                        />
                                    </Grid>

                                    <Grid item xs={4} sm={4}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <InputLabel id="lTipoRegion">Region</InputLabel>
                                            <Select
                                                labelId="lTipoRegion"
                                                id="STiporRegion"
                                                name="tiporRegion"
                                                value={regionVuelo}
                                                onChange={handleSelecRegionVuelo}
                                                label="Region"
                                                disabled={!circuitoSelect?.LPaqueteCircuitoRegion || circuitoSelect?.LPaqueteCircuitoRegion?.length <= 0}
                                            >
                                                <MenuItem value="0" disabled>
                                                    {circuitoSelect?.LPaqueteCircuitoRegion && circuitoSelect?.LPaqueteCircuitoRegion?.length <= 0 
                                                        ? "No hay regiones asignadas"
                                                        : "Seleccione una region"
                                                    }
                                                </MenuItem>
                                                {circuitoSelect?.LPaqueteCircuitoRegion
                                                    ?.filter(region => region.IncluyeVuelo === true)
                                                    .map((region, index) => (
                                                        <MenuItem key={region?.CatRegion.IdCatRegion} value={region?.CatRegion.IdCatRegion}>
                                                            {region?.CatRegion.Descripcion}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    
                                    <Grid item xs={4}>
                                        <PickerModHora
                                            id="fechaSalidaVuelo"
                                            label="Fecha de salida"
                                            selectedDate={detallesDeVuelo?.fechaSalida}
                                            setSelectedDate={(date) => {handleClickSelecFecha("fechaSalida", date)}}
                                            disablePast={true}
                                            disableFuture={false}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <PickerModHora
                                            id="fechaLlegadaVuelo"
                                            label="Fecha de llegada"
                                            selectedDate={detallesDeVuelo?.fechaLlegada}
                                            setSelectedDate={(date) => {handleClickSelecFecha("fechaLlegada", date)}}
                                            disablePast={true}
                                            disableFuture={false}
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <InputLabel id="lClaseVuelo">Clase de vuelo</InputLabel>
                                            <Select
                                                labelId="lClaseVuelo"
                                                id="SClaseVuelo"
                                                name="claseVuelo"
                                                value={claseVuelo}
                                                onChange={handleSelectClaseVuelo}
                                                label="Moneda"
                                            >
                                                <MenuItem value="0" disabled>
                                                    {"Seleccione una clase"}
                                                </MenuItem>
                                                {catalogoClases.map((clase, index) => (
                                                    <MenuItem key={clase.IdCatVueloClase} value={clase.IdCatVueloClase}>
                                                        {clase.Descripcion}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={4}>
                                        <TextField
                                            required
                                            id="input-Monto"
                                            label="Monto"
                                            type="text"
                                            variant="outlined"
                                            name="monto"
                                            value={formik.values.monto}
                                            onChange={formik.handleChange}
                                            error={formik.touched.monto && Boolean(formik.errors.monto)}
                                            helperText={formik.touched.monto && formik.errors.monto}
                                            className={classes.textField}
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                                            <Select
                                                labelId="lTipoMoneda"
                                                id="STipoMoneda"
                                                name="tipoMoneda"
                                                value={tipoMoneda}
                                                onChange={handleSelecTipoMoneda}
                                                label="Moneda"
                                            >
                                                <MenuItem value="0" disabled>
                                                    {"Seleccione una opción"}
                                                </MenuItem>
                                                {catalogoMoneda.map((moneda, index) => (
                                                    <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                                        {`${moneda.Clave} - ${moneda.Descripcion}`}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container style={{ margin: "0.5rem 10px" }}>
                                <div style={{ marginBottom: "0.5rem" }}>
                                    <strong>Extras que puede incluir el vuelo</strong>
                                </div>
                                <ExtrasCheckboxes 
                                    extrasList={normalizedExtras}
                                    selectedIds={selectedExtrasIds}
                                    onSelectionChange={(newIds) => {
                                        setSelectedExtrasIds(newIds);
                                        // Opcional: mantener compatibilidad con strings HTML
                                        setIncluye(convertExtrasToHTML(newIds, normalizedExtras, true));
                                        setNoIncluye(convertExtrasToHTML(newIds, normalizedExtras, false));
                                    }}
                                />
                            </Grid>
                        
                            <Grid item xs={12}>
                                <Grid container className={classes.containerSpacing}>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            label="Es vuelo redondo"
                                            labelPlacement="start"
                                            control={
                                                <Switch
                                                    checked={isRedondo}
                                                    onChange={handleChangeIsRedondo}
                                                    name="checkIsRedondo"
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                />
                                            }
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <TextField
                                            required
                                            id="input-claveVueloRegreso"
                                            label="Clave vuelo redondo"
                                            type="text"
                                            variant="outlined"
                                            name="claveVueloRedondo"
                                            value={formik.values.claveVueloRedondo}
                                            onChange={formik.handleChange}
                                            error={formik.touched.claveVueloRedondo && Boolean(formik.errors.claveVueloRedondo)}
                                            helperText={formik.touched.claveVueloRedondo && formik.errors.claveVueloRedondo}
                                            className={classes.textField}
                                            disabled={!isRedondo}
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <AutoInputIATA
                                            label="Origen regreso"
                                            name="OrigenRegreso"
                                            setTarget={setOrigenRegreso}
                                            value={origenRegreso}
                                            disabled={!isRedondo}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={4}>
                                        <AutoInputIATA
                                            label="Destino regreso"
                                            name="destinoRegreso"
                                            setTarget={setDestinoRegreso}
                                            value={destinoRegreso}
                                            disabled={!isRedondo}
                                        />
                                    </Grid>

                                    <Grid item xs={4}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <InputLabel id="lClaseVueloRedondo">Clase de vuelo</InputLabel>
                                            <Select
                                                labelId="lClaseVueloRedondo"
                                                id="SClaseVueloRedondo"
                                                name="claseVueloRedondo"
                                                disabled={!isRedondo}
                                                value={claseVueloRedondo}
                                                onChange={handleSelectClaseVueloRedondo}
                                                label="Moneda"
                                            >
                                                <MenuItem value="0" disabled>
                                                    {"Seleccione una clase"}
                                                </MenuItem>
                                                {catalogoClases.map((clase, index) => (
                                                    <MenuItem key={clase.IdCatVueloClase} value={clase.IdCatVueloClase}>
                                                        {clase.Descripcion}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={4}>
                                        <PickerModHora
                                            id="fechaSalidaVueloRedondo"
                                            label="Fecha de salida vuelo redondo"
                                            selectedDate={detallesDeVuelo?.fechaSalidaRedondo}
                                            setSelectedDate={(date) => {handleClickSelecFecha("fechaSalidaRedondo", date)}}
                                            disablePast={true}
                                            disableFuture={false}
                                            disabled={!isRedondo}
                                        />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <PickerModHora
                                            id="fechaRegresoVueloRedondo"
                                            label="Fecha de regreso vuelo redondo"
                                            selectedDate={detallesDeVuelo?.fechaLlegadaRedondo}
                                            setSelectedDate={(date) => {handleClickSelecFecha("fechaLlegadaRedondo", date)}}
                                            disablePast={true}
                                            disableFuture={false}
                                            disabled={!isRedondo}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container className={classes.containerSpacing} style={{margin: "1.5rem 0"}}>

                            <Grid item xs={6} className={classes.modalBotonesCenter}>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    className={classes.modalBoton}
                                    onClick={() => handleClick(true)} // Cerrar el formulario
                                >
                                    Guardar y finalizar
                                </Button>
                            </Grid>

                            <Grid item xs={6} className={classes.modalBotonesCenter}>
                                <Button
                                    type="button" // Cambiado a type="button" para evitar el envío del formulario
                                    variant="contained"
                                    color="primary"
                                    className={classes.modalBoton}
                                    onClick={() => handleClick(false)} // Guardar y crear nuevo
                                >
                                    Guardar y crear nuevo
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
            </ModalBase>
        </>
    )
}
export default FProveedoresVuelos